$(($) => {
	const wrapperDiv = $('.bs-div--careers-micro-blog-filter');
	if(wrapperDiv.length === 0) return;

	const filter = wrapperDiv.find('.facetwp-type-fselect');
	const filterButton = wrapperDiv.find('.bs-pro-button__container');


	const slideUp = () => {
		filter.find('.fs-wrap .fs-dropdown').slideUp(400);
		filter.removeClass('opened');
	}

	const slideUpOnCLickBody = (e) => {
		const dropdownDiv = filter.find('.fs-wrap .fs-dropdown');
		if (!dropdownDiv.is(e.target) && dropdownDiv.has(e.target).length === 0){
			slideUp();
			return;
		}
		$('body').one('click', (e) => slideUpOnCLickBody(e));
	}

	const slideDown = () => {
		filter.find('.fs-wrap .fs-dropdown').slideDown(400);
		filter.addClass('opened');
		$('body').one('click', (e) => slideUpOnCLickBody(e));
	}

	filterButton.on('click', (e) => {
		e.stopPropagation();
		if(filter.hasClass('opened')) {
			slideUp();
		} else {
			slideDown();
		}
	});

});
